module.exports = __webpack_public_path__ + "static/media/qrIcon.2daf126d.svg";